<template>
  <v-app>
    <core-toolbar />

    <core-drawer />

    <v-content id="view">
      <div id="home">
        <about />
        <boss />
        <workers />
        <requisite />
        <banner />
      </div>
    </v-content>

    <core-footer />
  </v-app>
</template>

<script>
  export default {
    name: 'Home',
    components: {
      CoreToolbar: () => import('@/components/core/Toolbar'),
      CoreDrawer: () => import('@/components/core/Drawer'),
      CoreFooter: () => import('@/components/core/Footer'),
      About: () => import('@/components/home/About'),
      Boss: () => import('@/components/home/Boss'),
      Workers: () => import('@/components/home/Workers'),
      Requisite: () => import('@/components/home/Requisite'),
      Banner: () => import('@/components/home/Banner')
    }
  }
</script>

<style>
  @import '../styles/main.css'
</style>
